import { useEffect, useState } from "react";

import DashboardAlpaca from "./pages/DashboardAlpaca";
import DashboardIBKR from "./pages/DashboardIBKR";
import Strategy from "./pages/Strategy";
import { decrypt, encrypt } from "../services/crypto";
import { api, setAuthorizationHeader } from "../services/api";

type AdminUser = {
    name: string;
    token: string;
}

type Page = "dashboard-alpaca" | "dashboard-ibkr" | "strategy";

export default function App() {

    const [username, setUsername] = useState("");
    const [password, setPassword] = useState("");

    const [message, setMessage] = useState("");

    const [user, setUser] = useState<null | string>(null);


    const [page, setPage] = useState<Page>("dashboard-ibkr");

    useEffect(() => {
        loadUser().then(user => {
            if (user) {
                setAuthorizationHeader("bearer " + user.token);
                // TODO: check if is mounted
                setUser(user.name);
            }
        })
    }, []);

    function handleLogOut() {
        setAuthorizationHeader("");
        saveUser(null);
        setUser(null);
        setMessage(`Byl jsi odhlášen.`);
    }

    async function handleLogin() {
        const [user, error] = await api.addLogin({ username, password });

        if (error) {
            setMessage(error);
            return;
        } else if (user) {
            saveUser(user);
            setAuthorizationHeader("bearer " + user.token);
            setMessage(`Jsi přihlášen jako: ${user.name}`);
            setUser(user.name);
        }
    }


    return <div>
        <div className="logo back" />
        <nav className="bg shadow">
            <div className="logo" />
            {/* <div className="title">Investiční nástroj</div> */}

            {user && <>
                <a onClick={() => setPage("dashboard-ibkr")} className={page === "dashboard-ibkr" ? "active" : ""}>IBKR</a>
                <a onClick={() => setPage("dashboard-alpaca")} className={page === "dashboard-alpaca" ? "active" : ""}>Alpaca</a>
                <a onClick={() => setPage("strategy")} className={page === "strategy" ? "active" : ""}>Strategie</a>
                <div className="grow-1" />
                <a onClick={handleLogOut}>Odhlásit se</a>
            </>}
        </nav>

        {!user && <form className="login-form bg shadow radius padding" onSubmit={e => {
            e.preventDefault();
            handleLogin();
        }}>
            <p><b>Pokud nejste Filip, prosím, opusťte tuto oblast!</b></p>

            {message && <p className="info">{message}</p>}

            <label>Jméno</label>
            <input type="text" value={username} onChange={e => setUsername((e.target as any).value)} />
            <label>Heslo</label>
            <input type="password" value={password} onChange={e => setPassword((e.target as any).value)} />
            <input type="submit" value="Přihlásit se" />
        </form>}

        {user && <>
            {page === "dashboard-ibkr" && <DashboardIBKR />}
            {page === "dashboard-alpaca" && <DashboardAlpaca />}
            {page === "strategy" && <Strategy />}
        </>}
    </div>;
}

const cryptPassword = "secret;)";

async function saveUser(user: null | AdminUser) {
    if (user === null) return localStorage.removeItem("admin");
    const cryptoUser = await encrypt(JSON.stringify(user), cryptPassword);
    localStorage.setItem("admin", cryptoUser);
}

async function loadUser(): Promise<null | AdminUser> {
    const user = localStorage.getItem("admin");
    if (!user) return null;

    try {
        const decryptedUser = await decrypt(user, cryptPassword);
        const parsedUser = JSON.parse(decryptedUser);
        if (
            parsedUser
            && typeof parsedUser === "object"
            && typeof parsedUser.name === "string"
            && typeof parsedUser.token === "string"
        ) return parsedUser;
    } catch (e) { }

    return null;
}
